import type { ExternalTableSchema } from '@packages/table-builder';

type AllocatedListFilter = NonNullable<ExternalTableSchema['dataSource']>['filters'] extends
  | (infer F)[]
  | undefined
  ? F
  : never;

/** Legacy useGetTransferAllocateIncludedList → TransferAllocateService allocated-list query mapping. */
export const transferAllocateAllocatedListRequestParams: Record<string, string> = {
  SearchKeyWord: 'table.searchText',
  Filter: '',
  MaxResultCount: 'table.pageSize',
  SkipCount: 'table.pageOffset',
  Sorting: 'table.sorting',
  GrantId: 'filters.grantName',
  AwardTypeId: 'filters.awardTypeId',
  FromDate: 'filters.createdFromDate',
  ToDate: 'filters.createdToDate',
  SettlementTypeIds: 'filters.settlementTypeIds',
  // `recordTypeId` — not `type` — avoids React Router nav state `type: 'drs'` leaking into filters.
  RecordTypeId: 'filters.recordTypeId',
};

export const transferAllocateAllocatedListFilters: AllocatedListFilter[] = [
  {
    name: 'createdFromDate',
    placeholder: 'Transaction Date From',
    type: 'date',
  },
  {
    name: 'createdToDate',
    placeholder: 'Transaction Date To',
    type: 'date',
  },
  {
    name: 'grantName',
    placeholder: 'Grant Name',
    type: 'asyncSelect',
    dataSource: {
      url: '/api/award/api/app/grant/grants',
      labelField: 'name',
      valueField: 'id',
    },
  },
  {
    name: 'awardTypeId',
    placeholder: 'Award',
    type: 'asyncSelect',
    dataSource: {
      url: '/api/award/api/app/plan-type/plan-type',
      labelField: 'displayName',
      valueField: 'id',
    },
  },
  {
    name: 'settlementTypeIds',
    placeholder: 'Settlement Type',
    type: 'asyncSelect',
    multiple: true,
    dataSource: {
      url: '/api/award/api/app/option-exercise/settlement-types',
      labelField: 'displayName',
      valueField: 'id',
    },
  },
  {
    name: 'recordTypeId',
    placeholder: 'Record Type',
    type: 'asyncSelect',
    dataSource: {
      url: '/api/award/api/app/status-dropdown-app-services/record-types-for-transfer-allocate',
      labelField: 'displayName',
      valueField: 'id',
    },
  },
];

/** Merge server schema without letting runtime JSON overwrite allocated-list filter wiring. */
export function withTransferAllocateAllocatedListDataSource<
  T extends ExternalTableSchema,
>(schema: T): T {
  return {
    ...schema,
    dataSource: schema.dataSource
      ? {
          ...schema.dataSource,
          requestParams: {
            ...transferAllocateAllocatedListRequestParams,
            ...schema.dataSource.requestParams,
            ...transferAllocateAllocatedListRequestParams,
          },
          filters: transferAllocateAllocatedListFilters,
        }
      : schema.dataSource,
  };
}
